export interface TemperatureMeasurement {
  measuredAt: string;
  value: number;
}

export interface TemperatureRange {
  start: string;
  end: string;
}

/** Selects raw measurements using start-inclusive and end-exclusive boundaries. */
export function filterMeasurementsForRange(
  measurements: TemperatureMeasurement[],
  range: TemperatureRange
): TemperatureMeasurement[] {
  const start = new Date(range.start).getTime();
  const end = new Date(range.end).getTime();

  return measurements.filter(({ measuredAt }) => {
    const timestamp = new Date(measuredAt).getTime();
    return timestamp >= start && timestamp < end;
  });
}

/** Returns the arithmetic mean, or null when no measurements are available. */
export function calculateTemperatureAverage(measurements: TemperatureMeasurement[]): number | null {
  if (!measurements.length) {
    return null;
  }

  return measurements.reduce((sum, measurement) => sum + measurement.value, 0) / measurements.length;
}
